<app-swipe-up
  *ngIf="isMobile; else desktopModal"
  [height]="95"
  (toggleShowSwipeUp)="closeBillingForm()"
  [showHeader]="true"
  [title]="'BOOKING_MODULE.BILLING.EMIT_BILL' | transloco"
  [subTitle]="descriptionMessage | transloco"
  [showSwipeUp]="showSwipeUpForm">
  <ng-container content>
    <ng-container *ngTemplateOutlet="billingFormTemplate"></ng-container>
  </ng-container>
</app-swipe-up>

<ng-template #desktopModal>
  <app-modal
    *ngIf="showSwipeUpForm"
    [width]="640"
    [showHeader]="true"
    [title]="'BOOKING_MODULE.BILLING.EMIT_BILL' | transloco"
    [subTitle]="descriptionMessage | transloco"
    (toggleModal)="closeBillingForm()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="billingFormTemplate"></ng-container>
    </ng-container>
  </app-modal>
</ng-template>

<ng-template #billingFormTemplate>
<div class="billingForm">
  <div class="billingForm__switch">
    <app-billing-section-switch
      [disabledCompanyBillingForm]="disabledCompanyBillingForm"
      [activeNaturalPerson]="activeNaturalPerson"
      [disbleSwitch]="hasDefaultBillingInfo"
      (clickSwitch)="onClickSwitch($event)"
    >
    </app-billing-section-switch>
  </div>
  <div *ngIf="activeNaturalPerson" class="billingForm__box">
    <app-person-billing-form
      [cities]="cities"
      [isMobile]="isMobile"
      [countries]="countries"
      [isVisibleParentNode]="showSwipeUpForm"
      [user]="user"
      [userAddresses]="userAddresses"
      [defaultBilling]="defaultBilling"
      [bookingForm]="formRef"
      [form]="billingForm"
      [firstPaxSelection]="firstPaxSelection"
      [businessRules]="businessRules"
      [bookingType]="bookingType"
      [withErrorLaunch]="withErrorLaunch"
      [activeNaturalPerson]="activeNaturalPerson"
      (create)="create.emit($event)"
      (update)="updateForm($event)">
    </app-person-billing-form>
  </div>
  <div *ngIf="showCompanyBillingForm" class="billingForm__box">
    <app-company-billing-form
      [isVisibleParentNode]="showSwipeUpForm"
      [isMobile]="isMobile"
      [cities]="cities"
      [countries]="countries"
      [user]="user"
      [bookingForm]="formRef"
      [userAddresses]="userAddresses"
      [defaultBilling]="defaultBilling"
      [form]="billingForm"
      [businessRules]="businessRules"
      [bookingType]="bookingType"
      [withErrorLaunch]="withErrorLaunch"
      [activeNaturalPerson]="activeNaturalPerson"
      (create)="create.emit($event)"
      (update)="updateForm($event)">
    </app-company-billing-form>
  </div>
</div>
</ng-template>